import { focusItems } from "@/mocks/archive";

export default function FocusFeed() {
  const [main, ...rest] = focusItems;
  return (
    <section id="focus" className="bg-background-50 border-t border-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="flex items-end justify-between gap-4 flex-wrap">
          <div>
            <p className="flex items-center gap-2 text-sm font-medium text-accent-700">
              <i className="ri-flashlight-line" />
              今日焦点 · 旧料头条
            </p>
            <h2 className="mt-2 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              正在被重新掘出的旧料
            </h2>
          </div>
          <a
            href="#zones"
            className="hidden md:inline-flex items-center gap-1 text-sm font-medium text-primary-700 hover:text-primary-600 whitespace-nowrap"
          >
            查看全部分类
            <i className="ri-arrow-right-s-line text-lg" />
          </a>
        </div>

        <div className="mt-8 grid grid-cols-1 lg:grid-cols-3 gap-5">
          {/* 头条大卡 */}
          <a
            href="#deep"
            className="group lg:col-span-2 rounded-lg overflow-hidden border border-background-200 bg-background-100 flex flex-col md:flex-row"
          >
            <div className="md:w-1/2 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Overhead%20view%20of%20old%20newspapers%20and%20typed%20documents%20with%20handwritten%20notes%20and%20subtle%20red%20highlighter%20marks%2C%20vintage%20archival%20research%20workspace%2C%20warm%20amber%20lamplight%2C%20cream%20paper%20and%20bronze%20accents%2C%20editorial%20magazine%20photography%2C%20high%20detail%20but%20restrained%20and%20tasteful&width=1200&height=800&seq=feature-archive-2026-x1&orientation=landscape"
                alt="被反复下架的早年黑历史帖子考古存证"
                title="全网黑料早年黑历史旧料被扒存证"
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="md:w-1/2 p-6 md:p-7 flex flex-col justify-center">
              <div className="flex items-center gap-2 text-xs">
                <span className="rounded-full bg-accent-500 px-2.5 py-1 font-medium text-background-50 whitespace-nowrap">
                  焦点旧料
                </span>
                <span className="text-foreground-500">始于 {main.year}</span>
              </div>
              <h3 className="mt-4 font-heading text-xl md:text-2xl font-bold leading-snug text-foreground-950 group-hover:text-primary-700 transition-colors">
                {main.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600 line-clamp-3">
                {main.summary}
              </p>
              <span className="mt-5 inline-flex items-center gap-1 text-sm font-semibold text-primary-700 whitespace-nowrap">
                {main.meta}
                <i className="ri-arrow-right-line" />
              </span>
            </div>
          </a>

          {/* 右侧副焦点列表 */}
          <div className="flex flex-col gap-5">
            {rest.map((item) => (
              <a
                key={item.id}
                href="#deep"
                className="group flex-1 rounded-lg border border-background-200 bg-background-100 p-5 flex flex-col justify-center hover:border-primary-300 transition-colors"
              >
                <div className="flex items-center gap-2 text-xs">
                  <span className="rounded-full bg-secondary-200 px-2.5 py-1 font-medium text-secondary-900 whitespace-nowrap">
                    {item.kind}
                  </span>
                  <span className="text-foreground-400">{item.year}</span>
                </div>
                <h3 className="mt-3 font-heading text-base md:text-lg font-bold leading-snug text-foreground-900 group-hover:text-primary-700 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 line-clamp-2">{item.summary}</p>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}